/**
 * Quotes from the people the work was for. The bundled entries are DRAFT
 * COPY — realistic samples, not transcribed from real interviews — and stand
 * only until the CMS has answered: from then on this list is exactly what the
 * CMS publishes (consent recorded for every one), and empty means the
 * section is not shown.
 */

export interface TestimonialItem {
    quote: string;
    name: string;
    /** Role or place; may be empty. */
    role: string;
    /** Portrait; empty means the card shows the initials. */
    avatar: string;
    initials: string;
}

export const initialsOf = (name: string): string =>
    name
        .split(/\s+/)
        .filter(Boolean)
        .slice(0, 2)
        .map((w) => w[0]?.toUpperCase() ?? '')
        .join('');

/** What people say about the work, as the CMS records it. */
export const TESTIMONIALS: TestimonialItem[] = [];
